module.exports = __webpack_public_path__ + "static/img/Akko-Genius-Concierge-Logo.cb726db.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/Akko-Genius-Concierge-Logo.png
// module id = 644
// module chunks = 0